/**
 * 人力资源部意见
 */
export default Object.freeze({
    AGREE: '1', // 同意
    DISAGREE: '2', // 不同意
    // REJECT: '2', // 退回
})